import styled from 'styled-components/macro';

export const Container = styled.div`
  line-height: ${({ theme }) => `${theme.getValue(12)}px`};
`;

export const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${({ theme }) => `${theme.getValue(16)}px`};
  margin-bottom: ${({ theme }) => `${theme.getValue(48)}px`};
  column-gap: ${({ theme }) => `${theme.getValue(20)}px`};
`;

export const Description = styled.p`
  color: ${({ theme }) => `${theme.colors.gray1}`};
  font-family: ${({ theme }) => `${theme.fonts.primary}`};
  font-size: ${({ theme }) => `${theme.getValue(16)}px`};
  line-height: ${({ theme }) => `${theme.getValue(24)}px`};
  font-weight: ${({ theme }) => `${theme.weights.normal}`};
  margin-bottom: ${({ theme }) => `${theme.getValue(8)}px`};
`;

export const BusinessTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => `${theme.getValue(19)}px`};
  gap: ${({ theme }) => `${theme.getValue(10)}px`};
`;

export const Headline2 = styled.p`
  color: ${({ theme }) => `${theme.colors.gray1}`};
  font-family: ${({ theme }) => `${theme.fonts.primary}`};
  font-size: ${({ theme }) => `${theme.getValue(12)}px`};
  line-height: ${({ theme }) => `${theme.getValue(17)}px`};
  font-weight: ${({ theme }) => `${theme.weights.bold}`};
  margin: ${({ theme }) => `${theme.getValue(24)}px 0 ${theme.getValue(7)}px`};
`;

export default { Container, ButtonSection, Label: Description, BusinessTypeContainer, Headline2 };
